import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onSourceClick", "data", "disabled"];
import { useMemo, createContext, useContext } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Source as StandaloneSource } from './Source';
import { Section as StandaloneSection } from './Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SourcesListContext = /*#__PURE__*/createContext(null);
function SourcesList({
  children,
  title,
  onSourceClick,
  footer
}) {
  const contextValue = useMemo(() => ({
    onSourceClick: onSourceClick
  }), [onSourceClick]);
  return /*#__PURE__*/_jsx(SourcesListContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      children: [title && /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: title
      }), children, footer && /*#__PURE__*/_jsx(Flex, {
        children: footer
      })]
    })
  });
}
function Section(props) {
  return /*#__PURE__*/_jsx(StandaloneSection, Object.assign({}, props));
}
function Source(_ref) {
  let {
      onSourceClick: localOnSourceClick,
      data,
      disabled
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const context = useContext(SourcesListContext);
  if (!context) {
    throw new Error('Source component must be used within SourcesList');
  }
  const {
    onSourceClick: contextOnSourceClick
  } = context;
  const handleClick = () => {
    localOnSourceClick === null || localOnSourceClick === void 0 || localOnSourceClick(data);
    contextOnSourceClick === null || contextOnSourceClick === void 0 || contextOnSourceClick(data);
  };
  return /*#__PURE__*/_jsx(StandaloneSource, Object.assign({}, props, {
    data: data,
    onClick: handleClick,
    disabled: disabled
  }));
}
SourcesList.Section = Section;
SourcesList.Source = Source;
SourcesList.displayName = 'SourcesList';
export { SourcesList, Section, Source };